export const environment = {
  production: true,
  testMode: false,
  contextPath: '/deq-search',
  gisURLS:{}
};
